import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {StateReliability} from '../shared/classes/StateReliability';

@Injectable({
  providedIn: 'root',
})
export class ReliabilityService {

  private http = inject(HttpClient);

  constructor() { }

  public getReliabilityMetrics(stateAbbreviation: string, year: number): Observable<StateReliability> {
    const url = '/api/reliability/state';
    const params = new HttpParams()
      .set('stateAbbv', stateAbbreviation)
      .set('year', year.toString());
    return this.http.get<StateReliability>(url, { params }).pipe(
      map(response => new StateReliability(response)),
    );

  }
}
